// Música de fondo compartida: se precarga durante la bienvenida y suena al salir el logo.
let el = null;
let armed = false;
const subs = new Set();
const EVTS = ["pointerup", "touchend", "click", "mousedown", "keydown"];

const notify = () => subs.forEach((f) => f(!!el && !el.paused));

function onGesture(e) {
  if (e?.target?.closest?.("[data-testid=audio-bg-float]")) return disarm();
  el?.play().then(disarm).catch(() => {});
}
function arm() {
  if (armed) return;
  armed = true;
  EVTS.forEach((ev) => window.addEventListener(ev, onGesture, true));
}
function disarm() {
  armed = false;
  EVTS.forEach((ev) => window.removeEventListener(ev, onGesture, true));
}

export const primeMusic = (url) => {
  if (!url) return null;
  if (!el) {
    el = new Audio();
    el.loop = true;
    el.preload = "auto";
    el.setAttribute("playsinline", "");
    el.addEventListener("play", notify);
    el.addEventListener("pause", notify);
  }
  const abs = new URL(url, window.location.href).href;
  if (el.src !== abs) {
    el.src = abs;
    el.load();
  }
  if (el.paused) arm();
  return el;
};

export const startMusic = (url) => {
  const a = primeMusic(url);
  a?.play().then(disarm).catch(arm);
};

export const toggleMusic = () => {
  if (!el) return;
  disarm();
  if (el.paused) el.play().catch(() => {});
  else el.pause();
};

export const stopMusic = () => {
  disarm();
  el?.pause();
};

export const subscribeMusic = (f) => {
  subs.add(f);
  f(!!el && !el.paused);
  return () => subs.delete(f);
};

export const findBgMusic = (node) => {
  if (!node || typeof node !== "object") return null;
  if (Array.isArray(node)) {
    for (const n of node) {
      const u = findBgMusic(n);
      if (u) return u;
    }
    return null;
  }
  if (node.type === "audio" && node.mode !== "card" && node.url) return node.url;
  return findBgMusic(node.blocks) || findBgMusic(node.children) || findBgMusic(node.items);
};
